import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M9 9h4m-4 6h3m-3-3h6"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-opacity": ".15",
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M2.055 9.73c0-2.842-.314-5.079 2.944-5.079h13.108c3.097-.058 4.069.511 4.069 3.492 0 2.525.058 6.453.058 7.8 0 2.72-1.088 3.58-3.867 3.58H6.18c-3.33.086-4.155-.743-4.155-2.945 0-1.834.029-4.788.029-6.849z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }